import React, { PureComponent } from "react";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
import fetchHandler from "@/fetch/fetchHandler";
import moment from "moment";
import { Modal } from "antd";
import { getStatusCodeList, stubFaultReportedlevelData } from "@/fetch/fetchApi";
import RefreshGrid from "@/utils/refreshGrid";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
// import { OPERATIONS_LEVEL } from '@/utils/mapObj';

// eslint-disable-next-line arrow-parens
@connect((state) => state)
class ErrorCodeManage extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.faultReportingList;
    this.state = {
      levelOption: [],
      formConfig: null,
      typeOption: [
        {
          text: this.props.intl.messages.faultReportingList.operationMode1, // '全部',
          value: "",
        },
      ],
      adviceContent: null,
      adviceVisible: false,
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.getLevel();
    this.setState({
      formConfig: this.initFormConfig(),
    });
    this.init();
  }

  componentDidMount() {
    const param = {
      date: `${moment(new Date()).subtract(0, "d").format("YYYY-MM-DD")},${moment(new Date())
        .subtract(0, "d")
        .format("YYYY-MM-DD")}`,
    };

    this.fetchApi(param);
  }

  // 获取故障等级
  getLevel() {
    fetchHandler(stubFaultReportedlevelData, {
      type: "1",
    }).then((res) => {
      const list = res.data.map((item) => {
        const foo = {
          text: item.name,
          value: item.id,
        };
        return foo;
      });
      const first = {
        text: this.internationalization.operationMode1, // '全部',
        value: "",
      };
      list.unshift(first);
      this.setState(
        {
          levelOption: [...list],
        },
        () => {
          this.setState({
            formConfig: this.initFormConfig(),
          });
        },
      );
      this.init();
    });
  }

  init() {
    this.setState({
      tableConfig: {
        tableKey: "errorCodeManageTable",
        tableColumns: [
          {
            name: "状态码", // 7'状态码',
            key: "code",
            colType: "textCol",
            align: "left",
          },
          {
            name: "状态名称", // '状态名称',
            key: "codeName",
            colType: "tipCol",
            align: "left",
          },
          {
            name: "触发方", // '触发方',
            key: "tiggerName",
            colType: "textCol",
            align: "left",
          },
          {
            name: "是否告警", // '是否告警',
            key: "isAlert",
            colType: "textCol",
            align: "left",
            render: (text) => {
              if (text === 1) {
                return "是";
              }
              return "否";
            },
          },
          {
            name: this.internationalization.title10, // '运维等级',
            colType: "textCol",
            align: "left",
            render: (value, row) => {
              return (
                <div
                  style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
                  {row.levelName && row.levelName !== "--" && (
                    <div className="tip-lv">
                      <span className="first" style={{ background: row.color }}></span>
                      <span className="last" style={{ background: row.color }}></span>
                    </div>
                  )}
                  <span>{row.levelName}</span>
                </div>
              );
            },
          },
          {
            name: "是否影响充电", // '是否影响充电',
            key: "isCharging",
            colType: "textCol",
            align: "left",
            render: (text) => {
              if (text === 1) {
                return "是";
              }
              return "否";
            },
          },
          {
            name: "停止原因分类", // '停止原因分类',
            key: "statusTypeName",
            colType: "textCol",
            align: "left",
          },
          {
            name: "异常停止", // '异常停止',
            key: "isErrorStop",
            colType: "textCol",
            align: "left",
            render: (text) => {
              if (text === 1) {
                return "是";
              }
              return "否";
            },
          },
          {
            name: "是否影响计费", // '是否影响计费',
            key: "isBilling",
            colType: "textCol",
            align: "left",
            render: (text) => {
              if (text === 1) {
                return "是";
              }
              return "否";
            },
          },
          {
            name: "是否影响状态", // '是否影响计费',
            key: "isEffectStubStatus",
            colType: "textCol",
            align: "left",
            render: (text) => {
              if (text === 1) {
                return "是";
              }
              return "否";
            },
          },
          {
            name: "故障内容", // '故障内容',
            key: "desc",
            colType: "tipCol",
            align: "left",
          },
          {
            name: "运维建议", // '操作提示',
            key: "maintMsg",
            colType: "textCol",
            align: "left",
            render: (text) => {
              return text && text !== "--" ? (
                <a onClick={() => this.setState({ adviceContent: text, adviceVisible: true })}>
                  查看更多
                </a>
              ) : (
                "--"
              );
            },
          },
          {
            name: "操作", // 操作
            key: "action",
            colType: "action", // 操作列，可定义多种操作。
            actionMap: [
              {
                type: "href",
                actionName: "配置", // 默认actionName
                // 根据grid数据 自定义显示actionName
                handler: (res) => {
                  this.openTab(
                    { errorCodeInfo: res, levelOption: this.state.levelOption },
                    { key: "errorCodeConfig", titleText: "状态码配置" },
                  );
                },
              },
            ],
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: getStatusCodeList,
        autoRefresh: !1, // 设置为true 直接加载grid数据
      },
    });
  }

  initFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: this.internationalization.placeholder, // '请输入故障名称',
          param: {
            name: "code",
            type: "string",
          },
          labelName: "状态码", // '故障名称:',
          required: false,
        },
        {
          type: "select",
          options: this.state.levelOption,
          placeholder: this.internationalization.placeholder, // '请选择:',
          param: {
            name: "levelId",
            type: "string",
          },
          labelName: this.internationalization.title4, // '运维等级',
          required: !1,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              // icon: 'search',
              text: this.internationalization.btn1, // '查询'
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      defaultParams: {},
      tableKey: "errorCodeManageTable",
      tablePage: "故障上报",
    };

    return formConfig;
  };

  fetchApi = (param) => {
    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(param);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "errorCodeManageTable", param);
    }
  };

  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel gzsbTable">
          <ScGridTable config={this.state.tableConfig} />
        </div>
        <Modal
          title="运维建议"
          visible={this.state.adviceVisible}
          footer={null}
          onCancel={() => this.setState({ adviceVisible: false })}>
          <div dangerouslySetInnerHTML={{ __html: this.state.adviceContent }}></div>
        </Modal>
      </div>
    );

    return Content;
  }
}

export default injectIntl(ErrorCodeManage);



// WEBPACK FOOTER //
// ./src/AntD/pages/system/errorCodeManage/index.js